import { BackendErrorPayload } from '@paywithextend/components/dist/error.utils'
import axios from 'axios'
import queryString from 'query-string'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { GetUserConnectionsQueryParams } from 'src/app/PeopleContacts/redux/peopleContacts.actions'
import { PeopleMembersResponse } from 'src/models/people.models'
import { RootState } from 'src/redux/createRootReducer'
import { selectAuthedJsonApiRequestConfig } from 'src/redux/selectors/axios.selectors'

export const SET_RECEIPT_ATTACHMENT_IDS =
  'app/requestVirtualCard/SET_RECEIPT_ATTACHMENT_IDS'
export interface SetReceiptAttachmentIdsAction {
  type: typeof SET_RECEIPT_ATTACHMENT_IDS
  payload: {
    ids: string[]
  }
}
export const createSetReceiptAttachmentIds = (
  ids: string[],
): SetReceiptAttachmentIdsAction => ({
  type: SET_RECEIPT_ATTACHMENT_IDS,
  payload: {
    ids,
  },
})

// TODO: refactor all of this to work with GetPeopleMembersActions in src/app/PeopleMembers/redux/peopleMembers.actions.ts
export const GET_ORGANIZATION_MEMBERS_INIT =
  'app/requestVirtualCard/GET_ORGANIZATION_MEMBERS_INIT'
export const GET_ORGANIZATION_MEMBERS_SUCCESS =
  'app/requestVirtualCard/GET_ORGANIZATION_MEMBERS_SUCCESS'
export const GET_ORGANIZATION_MEMBERS_FAILURE =
  'app/requestVirtualCard/GET_ORGANIZATION_MEMBERS_FAILURE'

export type GetOrganizationMembersSuccessPayload = PeopleMembersResponse

export type GetOrganizationMembersFailurePayload = BackendErrorPayload<string>

export interface GetOrganizationMembersInitAction {
  type: typeof GET_ORGANIZATION_MEMBERS_INIT
}
export interface GetOrganizationMembersSuccessAction {
  type: typeof GET_ORGANIZATION_MEMBERS_SUCCESS
  payload: GetOrganizationMembersSuccessPayload
}
export interface GetOrganizationMembersFailureAction {
  type: typeof GET_ORGANIZATION_MEMBERS_FAILURE
  payload: GetOrganizationMembersFailurePayload
}

export type GetRequestVirtualCardMembersActions =
  | GetOrganizationMembersInitAction
  | GetOrganizationMembersSuccessAction
  | GetOrganizationMembersFailureAction

const createGetOrganizationMembersInitAction =
  (): GetOrganizationMembersInitAction => ({
    type: GET_ORGANIZATION_MEMBERS_INIT,
  })
const createGetOrganizationMembersSuccessAction = (
  payload: GetOrganizationMembersSuccessPayload,
): GetOrganizationMembersSuccessAction => ({
  type: GET_ORGANIZATION_MEMBERS_SUCCESS,
  payload,
})
const createGetOrganizationMembersFailureAction = (
  payload: GetOrganizationMembersFailurePayload,
): GetOrganizationMembersFailureAction => ({
  type: GET_ORGANIZATION_MEMBERS_FAILURE,
  payload,
})

export const getOrgMembers = (
  organizationId: string,
  queryParameters?: GetUserConnectionsQueryParams,
): ThunkAction<
  Promise<
    GetOrganizationMembersFailureAction | GetOrganizationMembersSuccessAction
  >,
  RootState,
  void,
  GetRequestVirtualCardMembersActions
> => {
  return async (
    dispatch: ThunkDispatch<
      RootState,
      void,
      GetRequestVirtualCardMembersActions
    >,
    getState: () => RootState,
  ): Promise<
    GetOrganizationMembersFailureAction | GetOrganizationMembersSuccessAction
  > => {
    dispatch(createGetOrganizationMembersInitAction())
    return axios
      .get<GetOrganizationMembersSuccessPayload>(
        `/organizations/${organizationId}/members?${queryParameters ? queryString.stringify(queryParameters) : ''}`,
        selectAuthedJsonApiRequestConfig(getState()),
      )
      .then(
        async (response) => {
          return dispatch(
            createGetOrganizationMembersSuccessAction(response.data),
          )
        },
        (err) => {
          return dispatch(
            createGetOrganizationMembersFailureAction(err.response.data),
          )
        },
      )
  }
}
